/**
 * Frontend types for Assistant API
 * These mirror the backend API contracts but are maintained independently
 */

export enum AIAssistantStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TEST = 'TEST',
}

export interface FlowiseFlowConfig {
  type: 'flowise';
  url: string;
  apiKey?: string;
  overrideConfig?: Record<string, unknown>;
}

export interface AgentFlowConfig {
  coordinator?: FlowiseFlowConfig;
  responseAssistant?: FlowiseFlowConfig;
}

export interface AssistantConfig {
  agentFlow?: AgentFlowConfig;
  buffer?: {
    enabled?: boolean;
    timeoutMs?: number;
  };
  messageSplit?: {
    enabled?: boolean;
    delayMs?: number;
  };
  test?: {
    allowedSenders?: string[];
  };
  webhook?: {
    url?: string;
    uuid?: string;
  };
}

export interface CreateAssistantDto {
  type?: string;
  channelConnectionId?: string;
  name: string;
  description?: string;
  status?: AIAssistantStatus;
  config?: AssistantConfig;
}

export interface UpdateAssistantDto {
  type?: string;
  channelConnectionId?: string;
  name?: string;
  description?: string;
  status?: AIAssistantStatus;
  config?: AssistantConfig;
}

export interface AssistantResponseDto {
  id: string;
  accountId: string;
  type: string;
  channelConnectionId?: string;
  channelConnectionName?: string;
  name: string;
  description?: string;
  status: AIAssistantStatus;
  config: AssistantConfig;
  createdAt: string;
  updatedAt: string;
}

export interface ListAssistantsResponseDto {
  assistants: AssistantResponseDto[];
}

export interface RegenerateWebhookResponseDto {
  webhookUrl: string;
  webhookUuid: string;
}
